import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash';

@Pipe({ name: 'customCalendarTextFont' })
export class CustomCalendarTextFontPipe implements PipeTransform {
  /**
   * Pipe filters the list of rooms-chat based on the search text provided
   *
   * @returns list of rooms filtered by search text or []
   * @param events
   * @param type
   */
  transform(value: any, type: string, headless = false): string | null {
    if (value && !headless && type === 'SIZE') {
      return `${value}px`;
    }
    if (value && headless && type === 'SIZE') {
      return parseInt(value, 10) / 0.75 + 'px';
    }
    if (value && type === 'COLOR') {
      return value;
    }
    if (type === 'COLOR') {
      return '#000000';
    }
    if (type === 'SIZE') {
      return '12px';
    }
    return null;
  }
}
